import { useMemo } from 'react';
import { Activity } from '../../models/view';
import { useAppSelector } from '../../store';

export const useScheduleItems = () => {
  const { programEvents, error: programEventsError, loading: programEventsLoading } = useAppSelector(
    (state) => state.programEvents,
  );
  const {
    graduwayEvents,
    error: graduwayEventsError,
    loading: graduwayEventsLoading,
  } = useAppSelector((state) => state.graduwayEvents);

  const scheduleItems = useMemo((): Activity[] => {
    const programEventItems: Activity[] = programEvents.map((event) => ({
      id: event.id.toString(),
      sfid: event.sfid,
      title: event.volunteerJob.name,
      description: event.description,
      dateTime: new Date(event.startDateTime),
      duration: event.duration,
      location: event.volunteerJob.locationInformation,
      source: 'programEvent',
    }));

    const graduwayEventItems: Activity[] = graduwayEvents
      .filter((event) => event.status === 'active' && event.eventDate)
      .map((event) => ({
        id: `graduway-${event.id}`,
        title: event.title,
        description: event.description,
        dateTime: new Date(event.eventDate!),
        location: event.location,
        source: 'graduwayEvent',
        eventUrl: event.eventUrl,
        eventTime: event.eventTime,
        imageUrl: event.imageUrl,
      }));

    return [...programEventItems, ...graduwayEventItems];
  }, [programEvents, graduwayEvents]);

  const error = programEventsError || graduwayEventsError;
  const loading = programEventsLoading || graduwayEventsLoading;

  return { scheduleItems, error, loading };
};
